import React from "react";
import ReactDOM from "react-dom/client";
import Terms from "./terms";
import "../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Terms />
  </React.StrictMode>,
);
